import React, { Component } from 'react';

//import './App.css';


export class DeckCard extends Component {
  render() {
    return (
		<div>
	    <div className={ "DeckCard " + this.props.cardBackground } />
			{/*<img src={require(`../images/${ this.props.cardBackground }.png`)} className={ "DeckCard" }/>*/}
		</div>
    )
  }
}

export default DeckCard;



// WEBPACK FOOTER //
// ./src/Components/DeckCard.js